import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b439f0e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "media" };
const _hoisted_2 = { class: "media-content" };
const _hoisted_3 = { class: "content" };
const _hoisted_4 = { class: "level is-mobile mb-2" };
const _hoisted_5 = { class: "level-left taskHeader" };
const _hoisted_6 = {
    key: 0,
    class: "fas fa-check-circle mr-2",
    style: { "color": "green" }
};
const _hoisted_7 = {
    key: 1,
    class: "fas fa-ban mr-2",
    style: { "color": "red" }
};
const _hoisted_8 = {
    key: 2,
    class: "fas fa-exclamation-circle mr-2",
    style: { "color": "red" }
};
const _hoisted_9 = {
    key: 3,
    class: "fas fa-file-alt mr-2"
};
const _hoisted_10 = { class: "taskTitle" };
const _hoisted_11 = { class: "tag is-info is-rounded has-text-weight-bold ml-3" };
const _hoisted_12 = {
    key: 4,
    class: "tag is-warning is-rounded has-text-weight-bold ml-3"
};
const _hoisted_13 = { class: "level is-mobile taskFooter" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "level-item" }, null, -1));
const _hoisted_15 = {
    key: 0,
    class: "level-item"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-info-circle mr-1" }, null, -1));
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { key: 1 };
const _hoisted_19 = {
    key: 1,
    class: "level-item"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-clock mr-1" }, null, -1));
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { key: 1 };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "level-item" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "divider" })
], -1));
const _hoisted_24 = { class: "level-item" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", { class: "mr-1" }, "Assigned To:", -1));
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "level-item" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "divider" })
], -1));
const _hoisted_27 = { class: "level-item" };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-comment-alt mr-2" }, null, -1));
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "level-item" }, null, -1));
import { computed } from "vue";
import { TaskType, TaskAudience, doINeedToActionTask, TaskStatus } from "@/core/model";
import { enumKey, formatCount, formatTimeRelativeToNow } from "@/core/utils";
import { Core } from "@minicity/core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TaskWidget',
    props: {
        task: {},
        highlighted: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const status = computed(() => {
            if (props.task.status == TaskStatus.COMPLETED)
                return "complete";
            if (props.task.status == TaskStatus.CANCELLED)
                return "cancelled";
            if (doINeedToActionTask(props.task))
                return "for_me_to_action";
            return props.task.status == TaskStatus.REVIEW_REQUIRED ? "under_review" : "not_for_me_to_action";
        });
        const notRequiredLabel = computed(() => {
            switch (props.task.taskType) {
                case "LIFT_2_0_BIRTH_RECORD_ORDER":
                case "LIFT_2_0_SOCIAL_SECURITY_ORDER":
                case "LIFT_2_0_STATE_ID_ORDER":
                case "LIFT_2_0_TB_TESTING":
                    return "Skipped";
                default:
                    return "Not Required";
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["box taskWidget p-3", [{ 'highlighted': _ctx.highlighted }, [status.value]]])
            }, [
                _createElementVNode("article", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("span", _hoisted_5, [
                                        (status.value == 'complete')
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                                            : _createCommentVNode("", true),
                                        (status.value == 'cancelled')
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                                            : (status.value == 'for_me_to_action')
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                                                : (_openBlock(), _createElementBlock("i", _hoisted_9)),
                                        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(enumKey)(_ctx.task.entityType, _unref(Core).EntityType)) + " " + _toDisplayString(_ctx.task.entityDescription ? ` - ${_ctx.task.entityDescription}` : ''), 1),
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(enumKey)(_ctx.task.taskType, _unref(TaskType))), 1),
                                        (_ctx.task.status == _unref(TaskStatus).REVIEW_REQUIRED)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Under Review "))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _hoisted_14,
                                    (['COMPLETED', 'CANCELLED'].includes(_ctx.task.status))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                            _hoisted_16,
                                            (_ctx.task.status == 'COMPLETED')
                                                ? (_openBlock(), _createElementBlock("strong", _hoisted_17, "Task Complete"))
                                                : (_ctx.task.status == 'CANCELLED')
                                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_18, _toDisplayString(notRequiredLabel.value), 1))
                                                    : _createCommentVNode("", true)
                                        ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                            _hoisted_20,
                                            (_ctx.task.dueAt)
                                                ? (_openBlock(), _createElementBlock("strong", _hoisted_21, "Due " + _toDisplayString(_unref(formatTimeRelativeToNow)(_ctx.task.dueAt)), 1))
                                                : (_openBlock(), _createElementBlock("strong", _hoisted_22, "Created " + _toDisplayString(_unref(formatTimeRelativeToNow)(_ctx.task.createdAt)), 1))
                                        ])),
                                    _hoisted_23,
                                    _createElementVNode("span", _hoisted_24, [
                                        _hoisted_25,
                                        _createTextVNode(_toDisplayString(_unref(enumKey)(_ctx.task.audience, _unref(TaskAudience))), 1)
                                    ]),
                                    _hoisted_26,
                                    _createElementVNode("span", _hoisted_27, [
                                        _hoisted_28,
                                        _createElementVNode("strong", null, _toDisplayString(_unref(formatCount)(_ctx.task.commentCount, "comment")), 1)
                                    ]),
                                    _hoisted_29
                                ])
                            ])
                        ])
                    ])
                ])
            ], 2));
        };
    }
});
